import { elexity } from '../utilities/TrendsGraphHelper';
import AuthenticatedComponent from '../utilities/AuthenticatedComponent';
import configuration from '../config';
import { formatCost, formatCommas } from '../utilities/HelperFunctions';

const authenticatedComponent = new AuthenticatedComponent();

////GRAPHS////
function initializeGraph(
  fromDate,
  toDate,
  activeFrequency,
  chartType,
  activeTab,
  currentGXId,
  billData,
  pieCallback
) {
  let configUrl;
  let dateRange;

  switch (activeTab) {
    case 'utilityCharges':
      configUrl = `/ahiapi/${currentGXId}/gridInterconnect/bills`;
      dateRange = [fromDate, toDate];
      break;
    case 'usageHistory':
      configUrl = `/ahiapi/${currentGXId}/gridInterconnect/bills`;
      dateRange = [fromDate, toDate];
      break;
    case 'peakDemand':
      configUrl = `/ahiapi/${currentGXId}/gridInterconnect/trendsGraphData/powerPeakDemand?focusFrom=${fromDate}&focusTo=${toDate}&groupBy=${activeFrequency}`;
      dateRange = [fromDate, toDate];
      break;
    case 'loadProfile':
      configUrl =
        '/ahiapi/{entityKey}/gridInterconnect/trendsGraphData/powerLoadProfile?' +
        `focusFrom=${fromDate}&focusTo=${toDate}`;
      dateRange = [fromDate, toDate];
      break;
    case 'weatherImpacts':
      configUrl = `/ahiapi/${currentGXId}/gridInterconnect/trendsGraphData/powerLoadProfile`;
      dateRange = null;
      break;
    default:
      configUrl = `/ahiapi/${currentGXId}/gridInterconnect/bills`;
      dateRange = [fromDate, toDate];
      break;
  }

  if (billData.length > 0 && chartType === 'pie') {
    graphPieTotals(activeTab, billData, fromDate, toDate, pieCallback);
  }

  elexity.gx.trends.initAuth(authenticatedComponent.generateAuthenticatedHeader());
  elexity.gx.trends.init(
    currentGXId,
    // 'https://demo01.elexity.net:447' + configUrl,
    configuration['backend_host'] + configUrl,
    `${activeTab}Graph`,
    activeTab,
    chartType,
    dateRange
  );
}

function graphPieTotals(activeGraph, data, fromTime, toTime, callback) {
  let tempData = data;
  let payload = {};
  let tempSeries;

  let tempDemandTotal = 0;
  let tempEnergyTotal = 0;
  let tempOtherTotal = 0;
  let tempTaxTotal = 0;
  let tempAllTotal = 0;

  let criticalTotal = 0;
  let onPeakTotal = 0;
  let midPeakTotal = 0;
  let offPeakTotal = 0;
  let superOffPeakTotal = 0;

  for (let i = 0; i < tempData.length; i++) {
    let tempTime = new Date(tempData[i].startDate).getTime();

    if (tempTime >= fromTime && tempTime <= toTime) {
      if (tempData[i].chargeTypeCosts !== null) {
        tempDemandTotal = tempDemandTotal + tempData[i].chargeTypeCosts.DEMAND;
        tempEnergyTotal = tempEnergyTotal + tempData[i].chargeTypeCosts.ENERGY;
        tempOtherTotal = tempOtherTotal + tempData[i].chargeTypeCosts.OTHER;
        tempTaxTotal = tempTaxTotal + tempData[i].chargeTypeCosts.TAX;
      }

      if (tempData[i].touPeaks !== null) {
        criticalTotal = criticalTotal + tempData[i].touPeaks.CRITICAL_PEAK.volumekWh;
        onPeakTotal = onPeakTotal + tempData[i].touPeaks.ON_PEAK.volumekWh;
        midPeakTotal = midPeakTotal + tempData[i].touPeaks.MID_PEAK.volumekWh;
        offPeakTotal = offPeakTotal + tempData[i].touPeaks.OFF_PEAK.volumekWh;
        superOffPeakTotal = superOffPeakTotal + tempData[i].touPeaks.SUPER_OFF_PEAK.volumekWh;
      }
    }
  }

  if (activeGraph === 'utilityCharges') {
    tempAllTotal = tempDemandTotal + tempEnergyTotal + tempOtherTotal + tempTaxTotal;

    tempSeries = [
      {
        name: 'Demand Cost',
        y: parseInt(Math.round((tempDemandTotal / tempAllTotal) * 100)),
        color: '#F96138',
      },
      {
        name: 'Energy Cost',
        y: parseInt(Math.round((tempEnergyTotal / tempAllTotal) * 100)),
        color: '#00DC92',
      },
      {
        name: 'Other Cost',
        y: parseInt(Math.round((tempOtherTotal / tempAllTotal) * 100)),
        color: '#FA974F',
      },
      {
        name: 'Tax Cost',
        y: parseInt(Math.round((tempTaxTotal / tempAllTotal) * 100)),
        color: '#2FE0E6',
      },
    ];

    elexity.gx.trends.utilityChargesPieSeries = tempSeries;
    payload = {
      tempSeries,
      demandTotal: formatCost(Math.round(tempDemandTotal)),
      energyTotal: formatCost(Math.round(tempEnergyTotal)),
      otherTotal: formatCost(Math.round(tempOtherTotal)),
      taxTotal: formatCost(Math.round(tempTaxTotal)),
      allTotal: formatCost(Math.round(tempAllTotal)),
    };
  } else if (activeGraph === 'usageHistory') {
    tempAllTotal = criticalTotal + onPeakTotal + midPeakTotal + offPeakTotal + superOffPeakTotal;

    tempSeries = [
      {
        name: 'Critical Peak',
        y: parseInt(((criticalTotal / tempAllTotal) * 100).toFixed(2)),
        color: '#F96138',
      },
      {
        name: 'On Peak',
        y: parseInt(((onPeakTotal / tempAllTotal) * 100).toFixed(2)),
        color: '#00DC92',
      },
      {
        name: 'Mid Peak',
        y: parseInt(((midPeakTotal / tempAllTotal) * 100).toFixed(2)),
        color: '#FA974F',
      },
      {
        name: 'Off Peak',
        y: parseInt(((offPeakTotal / tempAllTotal) * 100).toFixed(2)),
        color: '#2FE0E6',
      },
      {
        name: 'Super Off Peak',
        y: parseInt(((superOffPeakTotal / tempAllTotal) * 100).toFixed(2)),
        color: '#004C93',
      },
    ];

    elexity.gx.trends.usageHistoryPieSeries = tempSeries;
    payload = {
      tempSeries,
      criticalTotal: formatCommas(criticalTotal.toFixed(2), 'kWh'),
      onPeakTotal: formatCommas(onPeakTotal.toFixed(2), 'kWh'),
      midPeakTotal: formatCommas(midPeakTotal.toFixed(2), 'kWh'),
      offPeakTotal: formatCommas(offPeakTotal.toFixed(2), 'kWh'),
      superOffPeakTotal: formatCommas(superOffPeakTotal.toFixed(2), 'kWh'),
    };
  }

  callback(payload);
}

////BILLS////

function billPDFCallback(data) {
  let alink = document.createElement('a');
  alink.href = data.url;
  alink.click();
}

export { initializeGraph, graphPieTotals, billPDFCallback };
